<template>
<nav class="side-nav-component">
  <ul>
    <li v-for="(section, index) in sections" :key="index"></li>
  </ul>
</nav> 
</template>
<script>
export default {
  name: 'SideLoadNavComponent',
  props: {
    sections: Array
  },
  mounted () {
    window.addEventListener('scroll', function () {
      const posY = window.pageYOffset + (window.innerHeight / 2)
      const sections = document.querySelectorAll('main > div > section')

      const activeIndex = Array.from(sections).findIndex(section => {
        return posY > section.offsetTop && posY < section.offsetTop + section.clientHeight
      })

      try {
        document.querySelector('.side-nav-component ul li.active').classList.remove('active')
      } catch {
        //
      } finally {
        document.querySelectorAll('.side-nav-component ul li')[activeIndex].classList.add('active')
      }
    })
  },
}
</script>
